import {memo} from 'react';

import _ from 'topmeteo/utils/i18n';

import BaseDistance from './BaseDistance';

const Label = _('%(length)s km (FAI)');

const FAIDistance = props => <BaseDistance {...props} id="distancefai-info" label={Label} />;

export default memo(FAIDistance);
